




import * as breakpoint from '../interfaces/breakpoint';
import {
    getElemHeight,
    mediaBreakpoint,
} from '../lib/dom';





function setupOverlay (body : HTMLBodyElement, overlay : HTMLElement) {

    // Only show overlay on desktop
    if ( mediaBreakpoint(breakpoint.Dir.Down)(breakpoint.Size.MD) ) return;

    const menuItems : NodeListOf<HTMLElement> =
        document.querySelectorAll('.main-menu .menu > .menu-item-has-children')

    // Mouse events
    menuItems.forEach( (elem : HTMLElement) => {
        elem.addEventListener('mouseover', () => {
            body.classList.add('has-overlay');
            overlay.style.zIndex = "9";
        });
        elem.addEventListener('mouseout', () => body.classList.remove('has-overlay'));
    });

    // Hide on transition end
    overlay.addEventListener('transitionend', (evt : TransitionEvent) => {
        if ( evt.propertyName === 'opacity' )  {
            if ( getComputedStyle(overlay).opacity === '0' ) {
                overlay.style.zIndex = "-999";
            }
        }
    });

    setOverlayTopPosition(overlay);
}


// Fix top position based on header height
function setOverlayTopPosition (overlay : HTMLElement) {
    function setOverlayTop () {
        overlay.style.top = getElemHeight('.top-bar, .main-bar, .main-menu') - window.scrollY + 'px';
    }

    setOverlayTop();
    window.addEventListener('scroll', setOverlayTop);
}





export default function setupSubmenuHover () {
    window.addEventListener('load', () => {
        const body : HTMLBodyElement | null = document.querySelector('body');
        const overlay : HTMLElement | null = document.querySelector('.overlay');

        if (!body || !overlay) return;

        setupOverlay(
            body,
            overlay
        );
    });
}
